import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LogoItem } from '../../config/logos';

interface LogosGridProps {
  items: LogoItem[];
  title?: string | null;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
  className?: string;
}

function LogosGrid({
  items, title, titleTag = 'h2', className,
}: LogosGridProps) {
  const { t } = useTranslation('common');
  return (
    <>
      {title ? (
        <Row>
          <Col>
            {React.createElement(titleTag, null, title)}
          </Col>
        </Row>
      ) : null}
      <Row className={`logo-wrapper ${className || ''}`.trim()}>
        {items.map((logo) => {
          const alt = t(`logo.altText.${logo.id}`) || undefined;
          const href = t(`logo.href.${logo.id}`) || '#';
          return (
            <Col md="4" key={logo.id} className="text-center">
              <a href={href as string} target="_blank" rel="noreferrer">
                <img
                  alt={alt as string | undefined}
                  className="logo mx-auto d-block"
                  src={logo.imgSrc}
                  style={logo.width ? { width: logo.width } : undefined}
                />
              </a>
            </Col>
          );
        })}
      </Row>
    </>
  );
}
LogosGrid.defaultProps = {
  title: null,
  titleTag: 'h2',
  className: '',
};

export default LogosGrid;
